<!-- Иконка телефона для звонка в поддержку. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M7 5L9.5 4L12 9L10.5 10C11.3 11.7 12.6 13 14 13.8L15.2 12.4L20 14.8L19.2 17.5C18.8 18.7 17.6 19.4 16.4 19.1C10.4 17.7 6.3 13.6 4.9 7.6C4.6 6.4 5.5 5.4 7 5Z"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "PhoneIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
